import React, { useState, useEffect } from 'react';
// 🔥 1. هنستورد أدوات الراوتر
import { 
  BrowserRouter as Router, 
  Routes, 
  Route, 
  Navigate,
  useSearchParams
} from 'react-router-dom';
import { auth, db } from './firebase';
import { onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

// 🔥 2. هنستورد كل الصفحات
import LoginPage from './LoginPage';
import ClientDashboard from './ClientDashboard';
import SignupPage from './SignupPage'; // الصفحة الجديدة
import BillingPage from './BillingPage'; // صفحة الباقات
import ShopifyOnboardingPage from './ShopifyOnboardingPage'; // صفحة Shopify Onboarding
import KnowledgeBasePage from './KnowledgeBasePage'; // 📚 صفحة قاعدة المعرفة
import BostaPage from './BostaPage'; // 📦 صفحة إعدادات Bosta
import './App.css';
import { useI18n } from './i18n';

function App() {
  // � ALL hooks must be called FIRST - unconditionally (React rules)
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [autoLoginAttempted, setAutoLoginAttempted] = useState(false);
  const { t, lang, toggleLang } = useI18n();

  // 🔥 Auto-login with email & password if available
  useEffect(() => {
    const attemptAutoLogin = async () => {
      const email = localStorage.getItem('shopify_auto_email');
      const password = localStorage.getItem('shopify_auto_password');
      
      if (email && password && !autoLoginAttempted) {
        console.log('🔐 Shopify credentials found in localStorage - attempting auto-login...');
        setAutoLoginAttempted(true);
        
        try {
          const userCredential = await signInWithEmailAndPassword(auth, email, password);
          console.log('✅ Auto-login successful:', userCredential.user.uid);
          
          // مسح البيانات بعد الاستخدام
          localStorage.removeItem('shopify_auto_email');
          localStorage.removeItem('shopify_auto_password');
        } catch (error) {
          console.error('❌ Auto-login failed:', error);
          // مسح البيانات لو فشل
          localStorage.removeItem('shopify_auto_email');
          localStorage.removeItem('shopify_auto_password');
          localStorage.removeItem('shopify_auth_uid');
        }
      }
    };

    attemptAutoLogin();
  }, [autoLoginAttempted]);
  // 🔥 3. الكود بتاعك زي ما هو (ممتاز)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);
  
  // 🚨 AFTER hooks: Check for shop parameter to hijack render
  console.log('🔍 CHECKING URL PARAMETERS...');
  console.log('   Full URL:', window.location.href);
  console.log('   Pathname:', window.location.pathname);
  console.log('   Search string:', window.location.search);
  
  const params = new URLSearchParams(window.location.search);
  const shopParam = params.get('shop');
  const hostParam = params.get('host');
  const platformParam = params.get('platform');
  const uidParam = params.get('uid');
  const currentPath = window.location.pathname;
  
  console.log('   Parsed shop:', shopParam);
  console.log('   Parsed host:', hostParam);
  console.log('   Parsed platform:', platformParam);
  console.log('   Parsed uid:', uidParam);
  
  // 🔥 CRITICAL: Only hijack if:
  // 1. shop parameter exists
  // 2. NOT on /shopify-onboarding page
  // 3. NOT on /dashboard page (already redirected)
  // 4. NO uid parameter (if uid exists, redirect already happened)
  const shouldHijack = shopParam && 
                       currentPath !== '/shopify-onboarding' && 
                       currentPath !== '/dashboard' && 
                       !uidParam;
  
  // EARLY RETURN: If shop exists AND not on onboarding/dashboard page AND no uid, skip ALL auth logic
  if (shouldHijack) {
    console.log('🚨🚨🚨 HIJACK ACTIVATED: Shop parameter detected!');
    console.log('   Shop:', shopParam);
    console.log('   Host:', hostParam);
    console.log('   Platform:', platformParam);
    console.log('   → BYPASSING: Auth check, loading state, login page');
    console.log('   → RENDERING: ShopifyDashboardHandler component');
    
    // Return Shopify handler immediately (but AFTER all hooks)
    return <ShopifyDashboardHandler shop={shopParam} host={hostParam} />;
  }
  
  if (shopParam && currentPath === '/shopify-onboarding') {
    console.log('✅ On onboarding page - letting Router handle it normally');
  } else if (shopParam && uidParam) {
    console.log('✅ Shop + UID detected - letting Router handle dashboard normally');
  } else {
    console.log('❌ NO shop parameter found - continuing with normal auth flow');
  }

  // 🔥 5. كود التحميل زي ما هو (ممتاز)
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '20px',
        background: '#f4f3fb',
        color: '#1b1f2a',
        fontFamily: "'IBM Plex Sans Arabic', sans-serif"
      }}>
        <button
          type="button"
          onClick={toggleLang}
          style={{
            background: '#ffffff',
            color: '#6c5ce7',
            border: '1px solid #eceef3',
            borderRadius: '10px',
            padding: '8px 14px',
            cursor: 'pointer',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
          aria-label={t('lang.toggle')}
        >
          <span aria-hidden="true">🌐</span>
          <span>{lang === 'en' ? 'EN' : 'AR'}</span>
        </button>
        <div style={{
          width: '44px', height: '44px', borderRadius: '50%',
          border: '4px solid #e7e3fb', borderTopColor: '#6c5ce7',
          animation: 'rdspin 0.8s linear infinite'
        }} />
        <style>{`@keyframes rdspin{to{transform:rotate(360deg)}}`}</style>
        <div style={{ fontSize: '20px', fontWeight: 600 }}>{t('loading.app')}</div>
      </div>
    );
  }

  // 🔥 6. ده الراوتر الجديد (بديل الـ if القديمة)
  return (
    <Router>
      <Routes>
        {/* --- المسارات العامة (للي مش مسجل دخول) --- */}
        
        <Route 
          path="/" 
          element={
            !currentUser ? <LoginPage /> : <Navigate to="/dashboard" replace />
          } 
        />
        <Route 
          path="/signup" 
          element={
            !currentUser ? <SignupPage /> : <Navigate to="/dashboard" replace />
          } 
        />

        {/* --- المسارات المحمية (للي مسجل دخول) --- */}
        
        <Route 
          path="/dashboard" 
          element={<DashboardWrapperWithAuth currentUser={currentUser} />} 
        />

        {/* صفحة الباقات */}
        <Route 
          path="/billing" 
          element={<BillingPage />} 
        />

        {/* صفحة Shopify Onboarding */}
        <Route 
          path="/shopify-onboarding" 
          element={<ShopifyOnboardingPage />} 
        />

        {/* 📚 صفحة قاعدة المعرفة */}
        <Route 
          path="/knowledge-base" 
          element={<KnowledgeBasePage />} 
        />

        {/* 📦 صفحة إعدادات Bosta */}
        <Route 
          path="/bosta" 
          element={<BostaPage />} 
        />

        {/* لو كتب أي رابط غلط، رجعه للبداية */}
        <Route path="*" element={<Navigate to="/" replace />} />
        
      </Routes>
    </Router>
  );
}

// Wrapper يتحقق لو Super Admin ولا عميل عادي
function DashboardWrapperWithAuth({ currentUser }) {
  const [searchParams] = useSearchParams();
  const adminUidFromUrl = searchParams.get('admin');
  const clientUidFromUrl = searchParams.get('uid');
  const shopParam = searchParams.get('shop');
  const platformParam = searchParams.get('platform');
  
  // 🔥 لو جاي من Shopify، نتحقق من وجود بيانات العميل
  // BUT: If uid already exists in URL, skip ShopifyDashboardHandler (already authenticated)
  if (shopParam && platformParam === 'shopify' && !clientUidFromUrl) {
    return <ShopifyDashboardHandler shop={shopParam} />;
  }
  
  // 🔥 لو في uid (مع أو بدون admin)، يبقى مصرح بالدخول
  if (clientUidFromUrl) {
    return <DashboardWrapper user={null} />;
  }
  
  // لو مفيش uid ومفيش shop، يبقى عميل عادي لازم يكون مسجل دخول
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }
  
  return <DashboardWrapper user={currentUser} />;
}

// 🔥 Handler خاص بـ Shopify clients
function ShopifyDashboardHandler({ shop, host }) {
  console.log('🎯 ShopifyDashboardHandler MOUNTED');
  console.log('   Received shop:', shop);
  console.log('   Received host:', host);
  
  const [loading, setLoading] = useState(true);
  const [clientData, setClientData] = useState(null);
  const [needsOnboarding, setNeedsOnboarding] = useState(false);
  const { t, lang, toggleLang } = useI18n();

  useEffect(() => {
    console.log('🔄 ShopifyDashboardHandler useEffect running...');
    console.log('   Checking client for shop:', shop);
    
    const checkShopifyClient = async () => {
      try {
        console.log('🔍 Querying Firestore for shop:', shop);
        const clientsRef = collection(db, 'clients_api');
        const q = query(clientsRef, where('shopify_domain', '==', shop));
        const querySnapshot = await getDocs(q);

        console.log('📊 Query result: Found', querySnapshot.size, 'document(s)');

        if (querySnapshot.empty) {
          // Client doesn't exist yet - shouldn't happen normally
          console.warn('⚠️ Shopify client not found:', shop);
          console.warn('   → Redirecting to onboarding');
          setNeedsOnboarding(true);
        } else {
          const client = querySnapshot.docs[0].data();
          console.log('✅ Client found!');
          console.log('   onboarding_completed:', client.onboarding_completed);
          console.log('   auth_uid:', client.auth_uid);
          
          // Check if onboarding is completed
          // ✅ العميل جاهز لو: onboarding_completed = true AND auth_uid exists
          // ❌ العميل محتاج onboarding لو: onboarding_completed مش true أو auth_uid مش موجود
          if (client.onboarding_completed === true && client.auth_uid) {
            console.log('✅ Shopify client ready:', shop, 'auth_uid:', client.auth_uid);
            setClientData(client);
          } else {
            console.log('🔄 Shopify client needs onboarding:', shop);
            console.log('   onboarding_completed:', client.onboarding_completed);
            console.log('   auth_uid:', client.auth_uid);
            console.log('   → Redirecting to onboarding page');
            setNeedsOnboarding(true);
          }
        }
      } catch (error) {
        console.error('❌ Error checking Shopify client:', error);
        setNeedsOnboarding(true);
      } finally {
        setLoading(false);
      }
    };

    checkShopifyClient();
  }, [shop]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        background: '#f4f3fb',
        color: '#1b1f2a',
        fontSize: '20px',
        gap: '20px',
        fontFamily: "'IBM Plex Sans Arabic', sans-serif"
      }}>
        <button
          type="button"
          onClick={toggleLang}
          style={{
            background: '#ffffff',
            color: '#6c5ce7',
            border: '1px solid #eceef3',
            borderRadius: '10px',
            padding: '8px 14px',
            cursor: 'pointer',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
          aria-label={t('lang.toggle')}
        >
          <span aria-hidden="true">🌐</span>
          <span>{lang === 'en' ? 'EN' : 'AR'}</span>
        </button>
        <div style={{
          width: '44px', height: '44px', borderRadius: '50%',
          border: '4px solid #e7e3fb', borderTopColor: '#6c5ce7',
          animation: 'rdspin 0.8s linear infinite'
        }} />
        <style>{`@keyframes rdspin{to{transform:rotate(360deg)}}`}</style>
        <span style={{ fontWeight: 600 }}>{t('loading.shopifyCheck')}</span>
      </div>
    );
  }

  if (needsOnboarding) {
    return <Navigate to={`/shopify-onboarding?shop=${shop}&platform=shopify`} replace />;
  }

  if (clientData) {
    // ✅ Shopify clients go directly to dashboard with their uid (no login needed - they're authenticated via Shopify)
    return <Navigate to={`/dashboard?uid=${clientData.auth_uid}&shop=${shop}&platform=shopify`} replace />;
  }

  return <Navigate to="/" replace />;
}

// Wrapper للـ Dashboard عشان يقرأ الـ uid من الـ URL
function DashboardWrapper({ user }) {
  const [searchParams] = useSearchParams();
  const clientUidFromUrl = searchParams.get('uid');
  const adminUidFromUrl = searchParams.get('admin');
  const shopParam = searchParams.get('shop');
  const platformParam = searchParams.get('platform');
  
  console.log('🔍 DashboardWrapper Props:');
  console.log('  - user:', user);
  console.log('  - clientUidFromUrl:', clientUidFromUrl);
  console.log('  - shopParam:', shopParam);
  console.log('  - adminUidFromUrl:', adminUidFromUrl);
  console.log('  - isSuperAdminView:', !!adminUidFromUrl);
  
  // ✅ Pass shop parameter to dashboard for Shopify clients
  return <ClientDashboard 
    user={user} 
    viewingClientUid={clientUidFromUrl} 
    isSuperAdminView={!!adminUidFromUrl}
    shopifyShop={shopParam}
    platform={platformParam}
  />;
}

export default App;